module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cb-Db-Ef-Fb-Gd.5e472836.png";